// Mombasa excursions — real catalogue supplied by the client (flyer, 2026-08-03).
// Prices, titles and descriptions are the client's. Still pending from the client:
// photos, and — for a few — exact duration / inclusions / pick-up point.
// Those render graceful "on request" fallbacks in the product page until supplied.

export const mombasa = {
  slug: 'mombasa',
  name: 'Mombasa',
  title: 'Mombasa Excursions',
  tagline: 'Curated coastal experiences & safaris for the discerning traveller',
  intro:
    "Mombasa and the Kenyan coast blend Swahili history, marine wildlife and warm Indian Ocean adventure. From dhow sails to Kisite Marine Park and Old Town heritage walks to Tsavo safaris, our signature Mombasa excursions cover culture, nature, adventure and relaxation — each guided by knowledgeable local hosts.",
  heroImage: '/Images/excursions/fort-jesus.webp',
  pricingPending: false,
  excursions: [
    {
      id: 'JT004',
      slug: 'kisite-dhow-excursion',
      title: 'Kisite Dhow Excursion',
      category: 'Marine & Coastal',
      featured: true,
      rating: 5,
      teaser:
        'Sail to Kisite Marine Park for snorkelling in crystal-clear waters, with a visit to the historic Slave Cave.',
      description:
        'Board a traditional dhow and sail south to the Kisite-Mpunguti Marine Park — one of the finest snorkelling sites on the East African coast. Glide over coral gardens teeming with tropical fish, keep an eye out for dolphins, and stop at the historic Slave Cave on Wasini Island. A full day of marine wonder and Swahili coastal heritage.',
      duration: 'Full day (7 hrs)',
      startingPrice: 110,
      currency: 'USD',
      highlights: ['Traditional dhow sail', 'Snorkelling at Kisite Marine Park', 'Historic Slave Cave visit', 'Swahili seafood lunch on Wasini'],
      included: ['Transport in a 7-seater safari minivan', 'English-speaking driver guide', 'Swahili seafood lunch', 'Boat ride', 'Marine park entrance fees'],
      excluded: ['Tips & gratuities', 'Snorkelling gear (hire available)', 'Drinks & extra meals', 'Personal expenses'],
      meetingPoint: 'Pick-up from your Mombasa coast hotel (North Coast 0600hrs / South Coast 0700hrs)',
      images: ['/Images/excursions/kisite-dhow.webp'],
    },
    {
      id: 'JT001',
      slug: 'haller-park',
      title: 'Haller Park',
      category: 'Nature & Wildlife',
      teaser: 'Forest game walk — see antelopes, snakes, tortoises and hippos feeding at 4pm.',
      description:
        'Once a barren limestone quarry, Haller Park is now a lush wildlife sanctuary and one of Mombasa’s best nature outings. Take a guided forest game walk past antelopes, giant tortoises and reptiles, and time your visit for the famous hippo feeding at 4pm.',
      duration: 'Half day (afternoon)',
      startingPrice: 45,
      currency: 'USD',
      highlights: ['Guided forest game walk', 'Antelopes, tortoises & reptiles', 'Hippo feeding at 4pm'],
      included: [],
      excluded: [],
      meetingPoint: '',
      images: ['/Images/excursions/haller-park.webp', '/Images/excursions/haller-park-2.webp'],
    },
    {
      id: 'JT002',
      slug: 'tamarind-dinner-dhow',
      title: 'Tamarind Dinner Dhow',
      category: 'Dining & Entertainment',
      teaser: 'Sail into the evening with exquisite dining, live music and dance under the African stars.',
      description:
        'A signature Mombasa evening: cruise Tudor Creek aboard the Tamarind Dhow while enjoying a fine seafood dinner, live music and dance beneath the stars. Elegant, romantic and unforgettable.',
      duration: 'Evening',
      startingPrice: 80,
      currency: 'USD',
      highlights: ['Sunset creek cruise', 'Fine seafood dining', 'Live music & dance'],
      included: [],
      excluded: [],
      meetingPoint: '',
      images: ['/Images/excursions/tamarind-dinner-dhow.webp'],
    },
    {
      id: 'JT003',
      slug: 'afternoon-city-tour-mombasa-sundowner',
      title: 'Afternoon City Tour & Mombasa Sundowner',
      category: 'Cultural & City',
      teaser: "Explore Old Town's rich heritage and enjoy a stunning coastal sundowner.",
      description:
        "Wander the winding lanes of Mombasa Old Town, taking in Swahili-Arab architecture, spice shops and centuries of coastal history, before settling in for a stunning sundowner by the ocean.",
      duration: 'Afternoon',
      startingPrice: 80,
      currency: 'USD',
      highlights: ['Old Town heritage walk', 'Swahili-Arab architecture', 'Coastal sundowner'],
      included: [],
      excluded: ['Fort Jesus entry'],
      meetingPoint: '',
      images: ['/Images/excursions/afternoon-city-tour.webp', '/Images/excursions/afternoon-city-tour-2.webp'],
    },
    {
      id: 'JT006',
      slug: 'half-day-city-tour-fort-jesus',
      title: 'Half Day City Tour with Fort Jesus',
      category: 'Cultural & City',
      teaser: 'Discover the history and charm of Mombasa, including the iconic Fort Jesus.',
      description:
        'A half-day introduction to Mombasa’s history and character, centred on the UNESCO-listed Fort Jesus — the 16th-century Portuguese fortress guarding the old harbour — plus Old Town’s markets and landmarks.',
      duration: 'Half day',
      startingPrice: 60,
      currency: 'USD',
      highlights: ['Fort Jesus (UNESCO site)', 'Old Town markets', 'Guided city landmarks'],
      included: ['Fort Jesus visit'],
      excluded: [],
      meetingPoint: '',
      images: ['/Images/excursions/fort-jesus.webp'],
    },
    {
      id: 'JT007',
      slug: 'half-day-city-tour-fort-jesus-haller-park',
      title: 'Half Day City Tour with Fort Jesus & Haller Park',
      category: 'Cultural & City',
      teaser: 'A perfect blend of culture and nature — Fort Jesus and Haller Park in one tour.',
      description:
        'The best of both worlds in a single half-day: the history of Fort Jesus and Old Town paired with the wildlife of Haller Park. Ideal if your time in Mombasa is short but you want culture and nature together.',
      duration: 'Half day',
      startingPrice: 100,
      currency: 'USD',
      highlights: ['Fort Jesus & Old Town', 'Haller Park wildlife', 'Culture + nature combined'],
      included: [],
      excluded: ['Lunch'],
      meetingPoint: '',
      images: ['/Images/excursions/fort-jesus.webp', '/Images/excursions/haller-park-2.webp'],
    },
    {
      id: 'JT005',
      slug: 'bush-tour',
      title: 'Bush Tour',
      category: 'Unique Local Experiences',
      teaser: 'Immerse yourself in authentic village life — a local school, a traditional healer and traditional dances.',
      description:
        'Step beyond the resorts into authentic coastal village life. Meet a community, visit a local school, learn about traditional healing and enjoy vibrant traditional dances — a warm, genuine cultural exchange.',
      duration: '',
      startingPrice: 100,
      currency: 'USD',
      highlights: ['Authentic village life', 'Local school visit', 'Traditional dances'],
      included: [],
      excluded: [],
      meetingPoint: '',
      images: ['/Images/excursions/bush-tour.webp'],
    },
    {
      id: 'JT008',
      slug: 'tsavo-east-day-safari',
      title: 'Day Trip Safari to Tsavo East',
      category: 'Safari Adventures',
      teaser: 'Full-day safari adventure in Tsavo East, lunch included.',
      description:
        'Trade the beach for the bush on a full-day game drive into Tsavo East, one of Kenya’s largest national parks — famed for its red elephants, lions and vast open plains. Lunch included.',
      duration: 'Full day',
      startingPrice: 275,
      currency: 'USD',
      highlights: ['Tsavo East game drives', 'Red elephants & big game', 'Lunch included'],
      included: ['Lunch', 'Game drives'],
      excluded: [],
      meetingPoint: '',
      images: ['/Images/excursions/tsavo-east.webp'],
    },
    {
      id: 'JT009',
      slug: 'ngutuni-safari-1-night',
      title: '1 Night Ngutuni Safari',
      category: 'Safari Adventures',
      teaser: 'Overnight safari at Ngutuni with game drives and great wildlife encounters.',
      description:
        'An overnight escape to Ngutuni Sanctuary, bordering Tsavo East. Enjoy morning and evening game drives, a comfortable lodge stay and excellent close-up wildlife encounters.',
      duration: '1 night / 2 days',
      startingPrice: 350,
      currency: 'USD',
      highlights: ['Ngutuni Sanctuary', 'Morning & evening game drives', 'Lodge overnight stay'],
      included: [],
      excluded: [],
      meetingPoint: '',
      images: ['/Images/excursions/ngutuni-safari.webp'],
    },
    {
      id: 'JT010',
      slug: 'ngutuni-safari-2-nights',
      title: '2 Nights Ngutuni Safari',
      category: 'Safari Adventures',
      teaser: 'Extended safari in the heart of the wild — two nights at Ngutuni.',
      description:
        'A deeper safari experience: two nights at Ngutuni Sanctuary with multiple game drives, unhurried wildlife viewing and time to truly settle into the rhythm of the bush.',
      duration: '2 nights / 3 days',
      startingPrice: 600,
      currency: 'USD',
      highlights: ['Two nights in the bush', 'Multiple game drives', 'Unhurried wildlife viewing'],
      included: [],
      excluded: [],
      meetingPoint: '',
      images: ['/Images/excursions/ngutuni-two.webp'],
    },
    {
      id: 'JTHEM005',
      slug: 'malindi-day-trip',
      title: 'Malindi Day Trip',
      category: 'Cultural & City',
      teaser: 'Historic Malindi, the Gedi ruins and a glass-bottom boat over Malindi Marine Park.',
      description:
        'A full day exploring the idyllic seaside town of Malindi, steeped in history since Vasco da Gama landed here in 1498. See the Church of St Francis Xavier and the Vasco da Gama Pillar, wander the ruins of the mysterious lost town of Gedi near Watamu, and take a glass-bottom boat ride over Malindi Marine Park to view the reef. The day ends with lunch at the historic Hemingways Hotel.',
      duration: 'Full day (8 hrs)',
      startingPrice: 150,
      currency: 'USD',
      highlights: ['Gedi ruins', 'Vasco da Gama Pillar & Old Town', 'Glass-bottom boat, Malindi Marine Park'],
      included: ['Transport in a 7-seater safari minivan', 'Lunch', 'English-speaking driver guide', 'Gedi ruins entrance fees'],
      excluded: ['Tips & gratuities', 'Drinks', 'Personal expenses'],
      meetingPoint: 'Pick-up from your Mombasa coast hotel (North Coast 0700hrs / South Coast 0600hrs)',
      images: ['/Images/excursions/malindi.webp'],
    },
    {
      id: 'JTHEM006',
      slug: 'shimba-hills-rainforest-safari',
      title: 'Shimba Hills Rainforest Safari',
      category: 'Safari Adventures',
      teaser: 'The coast’s closest game park — rainforest, waterfalls and the rare sable antelope.',
      description:
        'A half-day safari to Shimba Hills National Reserve, the closest game park to the coast (56km from Mombasa). Its scenic hills and coastal rainforest are home to the rare sable antelope, elephant, buffalo, giraffe, leopard and monkeys, plus the beautiful Sheldrick Falls.',
      duration: 'Half day (4½ hrs)',
      startingPrice: 95,
      currency: 'USD',
      highlights: ['Coastal rainforest', 'Sheldrick Falls', 'Rare sable antelope & elephants'],
      included: ['Transport in a 7-seater safari minivan', 'English-speaking driver guide', 'Shimba Hills park entrance fees'],
      excluded: ['Lunch (optional add-on)', 'Tips & gratuities', 'Drinks', 'Personal expenses'],
      meetingPoint: 'Pick-up from your Mombasa coast hotel',
      images: ['/Images/excursions/shimba-hills.webp'],
    },
  ],
};
